import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {User} from '../../_models/user';
import { Config } from '../../_helper/config';

import { Observable } from 'rxjs';
import { BaseAUTHService } from './base.auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseAUTHService {
  
  constructor(protected http: HttpClient) {  super('acesso/usuario/'); }

  logon(user: User){
    const _url = Config.info.apiServer.auth.url + "token";

    this.setStorageMode(user.lembrar);

    const opts = {
      headers: new HttpHeaders({
        'Content-Type': 'x-www-form-urlencoded',
        'Authorization': 'Basic ' + btoa(Config.info.apiServer.auth.key + ':' + Config.info.apiServer.auth.pwd)
      })
    };

    const data = "grant_type=password&username=" + encodeURIComponent(user.usuario) + "&password=" + encodeURIComponent(user.senha)
    
    let pms = new Promise((resolve, reject)=>{
      this.http.post(_url, data, opts)
        .subscribe( res => {
          this.auth(res);
          resolve(res);
        },
        err => reject(err));
    });

    return pms;
  }

  reset(login){
    const _url = "reset";
    return this.send(_url, {Usuario:login, IdSistema: Config.info.apiServer.auth.key});
  }

  confirmReset(senha, token)
  {
    const _url = "confirmreset";
    return this.send(_url, {Senha:senha, Token: token });
  }

  get credential(){
    return this.getUser();
  }

  changePassword(password, passwordNew)
  {
    const _url = "changepassword";
    return this.send(_url, {SenhaAtual: password, SenhaNova: passwordNew });
  }

  updateResetSenha()
  {
    const credential = this.getUser();
    credential.resetSenha = 'False';
    this.auth(credential);
  }
}
